import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';

class ReportExplainer extends Component {
    constructor(props) {
        super();

        this.state = { descriptionHidden: props.descriptionHidden ?? true };
        this.handleShowDetails = this.handleShowDetails.bind(this);
    }

    handleShowDetails() {
        this.setState({ descriptionHidden: !this.state.descriptionHidden });
    }

    render() {
        const { t } = this.props;
        return (
            <div className={'explainer-wrapper'}>
                <div className={'explainer-container'}>
                    <div className={'explainer-main-block'}>
                        <div className={'explainer-main-block-item'}>
                            <img
                                className="logo-symbol"
                                loading="lazy"
                                alt="logo"
                                src="/static/img/report_explainer_icon.svg"
                            />
                            <p className={'explainer-title'}>
                                {this.props.title ?? t('global.report_explainer')}
                            </p>
                        </div>
                        <div className={'explainer-main-block-item'}>
                            <button
                                onClick={this.handleShowDetails}
                                className={'explainer-arrow-btn'}
                            >
                                <i
                                    className={
                                        this.state.descriptionHidden
                                            ? 'icon-enlarge2'
                                            : 'icon-shrink2'
                                    }
                                ></i>
                            </button>
                        </div>
                    </div>
                    <div
                        className={`explainer-additional-block ${
                            !this.state.descriptionHidden ? 'show' : ''
                        }`}
                    >
                        {this.props.isNotText ? (
                            this.props.textcontent
                        ) : (
                            <p>
                                {' '}
                                {t(`${this.props.textcontent}`, {
                                    defaultValue: this.props.textcontent,
                                })}
                            </p>
                        )}
                    </div>
                </div>
            </div>
        );
    }
}

export default withTranslation()(ReportExplainer);
